import { ComponentType, PropsWithChildren } from 'react';

import { Alert, ExternalLink, Stack, Typography } from '@cast/design-system';

import { PolicyCardForm } from './_components/PolicyCardForm';

import { RffCheckbox } from '@cast/shared-rff-ui';

import { getDocsLink } from '@cast/utils';

type MemoryGrowthDetectionFieldProps = {
  name: string;
  LabelComponent?: ComponentType<PropsWithChildren>;
};

export const MemoryGrowthDetectionField = ({
  name,
  LabelComponent,
}: MemoryGrowthDetectionFieldProps) => {
  return (
    <Stack gap={16} data-testid="memory-growth-detection-field">
      <PolicyCardForm
        label="Enable memory growth detection"
        LabelComponent={LabelComponent}
        control={
          <RffCheckbox
            name={name}
            size="small"
            testId="memory-growth-detection-input"
          />
        }
      />
      <Alert size="sm" color="info" noIcon>
        <Typography variant="P12R">
          When disabled, memory recommendations can exceed 1.5× current usage,
          which can be useful for workloads with expected continuous memory
          growth. See{' '}
          <ExternalLink
            link={getDocsLink('docs_woop_vpa_memory_growth_detection')}
            noIcon
          >
            documentation
          </ExternalLink>{' '}
          for more.
        </Typography>
      </Alert>
    </Stack>
  );
};
